angular.module('eCareVault.common.uploadDocuments', []);
